import moment from 'moment';

const utils = {
  install(Vue) {
    Vue.prototype.coverte_para_float_valor_input = (value) => {
      let stringValor = value;
      let valorFlutuante = parseFloat(stringValor.replace("R$", " ").replace(/\./g, "").replace(",", "."));

      return valorFlutuante;
    }

    Vue.prototype.formatInputFloat = (event, parentObject, propertyName) => {
      // Obtenha o valor do campo de entrada do evento
      let value = event.target.value;

      // Remova todos os caracteres não numéricos do valor de entrada
      let numericValue = value.replace(/\D/g, "");

      // Converta o valor numérico para um número de ponto flutuante
      let floatValue = parseFloat(numericValue / 100);

      // Formate o valor numérico para a moeda desejada (por exemplo, BRL)
      // Remove "R$" e espaços para evitar espaços no início
      let formattedValue = floatValue.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).replace("R$", "").trim();

      // Atualize o valor do campo de entrada com o valor formatado
      event.target.value = formattedValue;

      // Atualize o valor no objeto pai
      parentObject[propertyName] = event.target.value;
    };
    Vue.prototype.formatterCurrBR = (value) => {
      if (!parseFloat(value)) {
        return parseFloat(value).toFixed(2).replace(".", ",");
      }

      const formatoMoeda = {
        style: "currency",
        currency: "BRL"
      };
      // so funciona quando o numero é enviado de uma vez
      const formatValue = value.toLocaleString("pt-BR", formatoMoeda).replace("R$", "");
      return formatValue.replace(" ", "");
    }
    Vue.prototype.new_convert_srting_float = (value) => {
      let resultado = value;

      if (typeof resultado == "string") {

        if (resultado.includes('.') && resultado.includes(',')) {

          resultado = parseFloat(resultado.replace('.', '').replace(',', '.'));

        } else if ((!resultado.includes('.')) && resultado.includes(',')) {

          resultado = parseFloat(resultado.replace(',', '.'));

        } else if ((!resultado.includes('.')) && (!resultado.includes(','))) {
          resultado = parseFloat(resultado);
        }

      } else {

        resultado = value

      }
      return resultado;
    }

    // Formata números como moeda BR (sempre com casas decimais)
    Vue.prototype.formatterFloatBR = (value, fixed) => {
      const casas = Number.isInteger(fixed) ? fixed : 2;
      const numero = Number(value);

      // Trata valores inválidos sem lançar exceção
      if (Number.isNaN(numero)) {
        return (0).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: casas,
          maximumFractionDigits: casas,
        }).replace('R$', '').trim();
      }

      return numero
        .toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: casas,
          maximumFractionDigits: casas,
        })
        .replace('R$', '')
        .trim();
    }

    Vue.prototype.removeAccent = (value) => {
      let str = value;
      str = str.replace(/[ÀÁÂÃÄÅ]/g, "A");
      str = str.replace(/[àáâãäå]/g, "a");
      str = str.replace(/[ÈÉÊË]/g, "E");
      return str;
    }

    Vue.prototype.formatDateBR = (value) => {
      return (value) ? moment(value).format('DD/MM/yyyy') : '';
    }

    Vue.prototype.formatDateTimeBR = (value) => {
      return (value) ? moment(value).format('DD/MM/yyyy HH:MM') : '';
    }

    Vue.prototype.formatTimeBR = (value) => {
      return (value) ? moment(value, 'HH:mm:ss').format('HH:mm') : '';
    }

    // Truncate string limit
    Vue.prototype.truncate = (string, limit) => {
      return string.length > limit ? string.substring(0, limit) + '...' : string;
    }

    // Função para tocar o som de alerta
    Vue.prototype.playNotificationSound = () => {
      const audio = new Audio("data:audio/mp3;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4LjI5LjEwMAAAAAAAAAAAAAAA//OEAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAEAAABIwAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDDf39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f39/f//OEAAAAAAAAAAAAAAAAAAAAAAAAMGF1ZGlvYnVtcC5jb20wAAAAAAAAAAAAAAAAdvQAABAAABMgAAAAJTM4AAAAAAAAAAAAAP/zxEAAfUAUVwMAAAAAH0AAACex4iQcDAwMHAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwMLAwMDCwMDAwsDAwML");
      // String Base64 de um som curto de notificação (Glass/Drop)
      const audioSrc = audio;
      audioSrc.play();
    }
  }
}

export default utils